
<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-5">
                <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                    class="border-0">
                        <div class="text-muted text-center mb-3">
                            <small>Sign in with</small>
                        </div>
                        <div class="btn-wrapper text-center">
                            <base-button @click="LoginGoogle" type="danger" class="btn btn-block">
                                Google
                            </base-button>
                        </div>

                        <div class="text-center text-muted mb-4 my-3">
                            <small>Or sign in with credentials</small>
                        </div>
                        <form role="form">
                            <input  class="mb-3 form-control alternative" placeholder="Email/Mobile Number  " v-model="username" addon-left-icon="ni ni-email-83" />
                            <input class="mb-3 form-control alternative" type="password" v-model="password" placeholder="Password"
                                addon-left-icon="ni ni-lock-circle-open">
                            <div class="text-center">
                                <base-button type="primary" @click="runLoginSequence" class="my-4">Sign In</base-button>
                            </div>
                        </form>
                        <div class="signup-prompt">
                            <p class="mb-1"><strong>New to Umbai?</strong></p>
                            <p class="text-muted small mb-3">Create a company account to get test API credentials straight away.</p>
                            <router-link to="/signup" class="btn btn-outline-primary btn-block">Create a company account</router-link>
                        </div>
                </card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</div>